import type { ReactNode } from 'react'

/** Wraps legacy Assets inventory sections without changing behavior. */
export default function AssetInventoryTab({ children }: { children: ReactNode }) {
  return <>{children}</>
}
